import { ORDER_STATUS } from '../../enum/order';

export const truncateCancelName = (itemName?: string) => {
  return `${itemName} (${ORDER_STATUS.CANCELLED})`;
};
